import React from 'react';
import { useEnroll } from '../context/EnrollContext';
import styles from './UI.module.css';

export function ProofStrip() {
  const items = [
    { num: '500+', desc: 'Students Trained' },
    { num: '4.8★', desc: 'Average Rating' },
    { num: '100%', desc: 'Hands-On Projects' },
    { num: '₹0',   desc: 'Hidden Fees' },
    { num: '8+',   desc: 'Tools You\'ll Master' },
  ];

  return (
    <div className={styles.proofStrip}>
      <div className={styles.proofInner}>
        {items.map((item, i) => (
          <div className={styles.proofItem} key={i}>
            <div className={styles.proofNum}>{item.num}</div>
            <div className={styles.proofDesc}>{item.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function SectionLabel({ children, light }) {
  return (
    <p className={`${styles.sectionLabel} ${light ? styles.labelLight : ''}`}>
      {children}
    </p>
  );
}

export function SectionHeader({ label, title, subtitle, center, light }) {
  return (
    <div className={`${styles.sectionHeader} ${center ? styles.centered : ''}`}>
      <SectionLabel light={light}>{label}</SectionLabel>
      <h2 className={`${styles.sectionTitle} ${light ? styles.titleLight : ''}`}
          dangerouslySetInnerHTML={{ __html: title }} />
      {subtitle && (
        <p className={`${styles.sectionSub} ${light ? styles.subLight : ''}`}>{subtitle}</p>
      )}
    </div>
  );
}

export function UrgencyBanner() {
  const { open } = useEnroll();
  const segment = (key) => (
    <span key={key} className={styles.urgencyItem}>
      &nbsp;&nbsp;<strong>Next batch starts soon</strong>&nbsp;—&nbsp;Limited seats available
      &nbsp;&nbsp;&nbsp;·&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;<strong>+91&nbsp;73871&nbsp;36569</strong>
      &nbsp;&nbsp;&nbsp;·&nbsp;&nbsp;&nbsp;
      <a href="#" onClick={e => { e.preventDefault(); open(); }}>Reserve your seat →</a>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span>
  );
  return (
    <div className={styles.urgency}>
      <div className={styles.urgencyTrack}>
        {segment(0)}{segment(1)}
      </div>
    </div>
  );
}
